import type { ProductListingStoryblok } from "@/generated/sb/sb-types";

import BlokWrap from "@/components/ui/BlokWrap";
import { BloksRoute } from "@/data/routes/bloks.route";
import { ProductCardList } from "@/features/product/components/ProductCardList";
import { Link } from "@/i18n/routing";
import type { ProductCard as ProductCardType } from "@/lib/centra/formatters";
import { BlokProps, getLink } from "@frend-digital/storyblok";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import styles from "./ProductListingBlok.module.css";

export const ProductListingBlok = ({
  blok,
  data,
}: BlokProps<
  ProductListingStoryblok,
  BloksRoute["fetchProductListingCards"]
>) => {
  const link = blok?.link?.[0];
  const href = getLink(link?.link)?.href;
  const { spacingTopAdjustment = "normal" } = blok;

  return (
    <BlokWrap
      {...storyblokEditable(blok as unknown as SbBlokData)}
      animated="fadeY"
      className={clsx(
        styles.container,
        "product-listing",
        styles[spacingTopAdjustment],
      )}
    >
      <div data-layout="page" className={styles.head}>
        {blok.title && <h2>{blok.title}</h2>}
        {blok.link?.[0]?.text && (
          <Link href={href || "/"}>{blok.link?.[0]?.text}</Link>
        )}
      </div>

      <ProductCardList cards={data as unknown as ProductCardType[]} />
    </BlokWrap>
  );
};
